var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconVariate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.2251 12.5L14.5001 11.125L16.7751 12.5L16.1751 9.9L18.1751 8.175L15.5501 7.95L14.5001 5.5L13.4501 7.95L10.8251 8.175L12.8251 9.9L12.2251 12.5ZM12.7001 19H18.3001C18.1834 19.4333 17.9834 19.7833 17.7001 20.05C17.4167 20.3167 17.0501 20.4833 16.6001 20.55L5.70007 21.875C5.15007 21.9583 4.65423 21.8292 4.21257 21.4875C3.7709 21.1458 3.51673 20.7 3.45007 20.15L2.12507 9.225C2.0584 8.675 2.19173 8.18333 2.52507 7.75C2.8584 7.31667 3.30007 7.06667 3.85007 7L5.00007 6.85V8.85L4.10007 8.975L5.45007 19.9L12.7001 19ZM9.00007 17C8.45007 17 7.97923 16.8042 7.58757 16.4125C7.1959 16.0208 7.00007 15.55 7.00007 15V4C7.00007 3.45 7.1959 2.97917 7.58757 2.5875C7.97923 2.19583 8.45007 2 9.00007 2H20.0001C20.5501 2 21.0209 2.19583 21.4126 2.5875C21.8042 2.97917 22.0001 3.45 22.0001 4V15C22.0001 15.55 21.8042 16.0208 21.4126 16.4125C21.0209 16.8042 20.5501 17 20.0001 17H9.00007ZM9.00007 15H20.0001V4H9.00007V15Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconVariate);
export default __webpack_public_path__ + "static/media/icon-variate.1c6a6d6e92efd46a10357f60ca5107fa.svg";
export { ForwardRef as ReactComponent };